import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ReactElement } from "react";
import { IBankListInApplicationCreateProps } from "../../../../interfaces/props/IBankListInApplicationCreateProps";

import classes from "./BankListInApplicationCreate.module.css";

/**
 * Компонент отображения списка банков при создании заявки
 *
 * @param {IBankListInApplicationCreateProps} props - Пропсы компонента
 * @param {IBankForAdd[]} props.bankListForAdd - Список банков
 * @param {(id: number) => void} props.changeSelectBanks - Функция для изменения выбранных банков
 */
export function BankListInApplicationCreate(
  props: IBankListInApplicationCreateProps,
): ReactElement {
  const { bankListForAdd, changeSelectBanks } = props;

  function deleteBank(id: number) {
    changeSelectBanks(id);
  }

  return (
    <div className={classes.bankList}>
      {bankListForAdd?.map((bank) => (
        <div className={classes.bank} key={bank.id}>
          <div className={classes.bank__title}>{bank.title}</div>
          <Button
            className={classes.bank__deleteButton}
            type="text"
            aria-label="Удалить банк"
            size="small"
            onClick={() => deleteBank(bank.id)}
          >
            <CloseOutlined />
          </Button>
        </div>
      ))}
    </div>
  );
}
